import AnimatedSeparator from '../components/AnimatedSeparator';
import { Link } from 'react-router-dom';

export default function PortfolioPage() {
    return (
        <div className="page-container">
            <div className="container">
                <div className="row page-hero align-items-end">
                    <div className="col-md-7">
                        <h1>Nursery's Portfolio</h1>
                        <h2>ideas growing in the Nursery</h2>
                    </div>
                </div>

                <AnimatedSeparator color="#000" />

                <div className="row">
                    <div className="col-md-3">
                        <h3 style={{ color: '#f52e72' }}>MedaBeret</h3>
                    </div>
                    <div className="col-md-8 offset-md-1">
                        <h3>Fractal Literature Platform</h3>
                        <p>Redefining how we read and write books with interconnected stories that mimic the flow of real-world conversations.</p>
                        <div className="book-actions btn-row">
                            <Link to="https://medaberet.com" className="btn-secondary" target="_blank" rel="noreferrer">
                                learn more
                            </Link>
                        </div>
                    </div>
                </div>

                <AnimatedSeparator color="#f52e72" />

                <div className="row">
                    <div className="col-md-8">
                        <h3>Bicycle Rides Timing</h3>
                        <p>Navigation app for bicycle rides in the city that accurately times your routes by learning your riding patterns.</p>
                        <div className="book-actions btn-row">
                            <Link to="https://myttp.com/" className="btn-secondary" target="_blank" rel="noreferrer">
                                learn more
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-3 offset-md-1">
                        <h3 style={{ color: '#f52e72' }}>My Time-To-Places</h3>
                    </div>
                </div>

                <AnimatedSeparator color="#000" />

                <div className="row">
                    <div className="col-md-8">
                        <h5>Ready to submit your idea?</h5>
                        <p style={{ marginBottom: '2rem' }}>
                            Your idea remains yours — it is protected by a non-disclosure agreement.
                        </p>
                        <Link to="/submit-idea" className="btn-primary">submit your idea</Link>
                    </div>
                </div>

            </div>
        </div>
    )
}